import { createContext } from 'react';

const PBContext = createContext({ hasGTM: false });

export default PBContext;
